module.exports = __webpack_public_path__ + "assets/img/5_1356.d32b2ec5.jpg";